/**
 * Seller Products page: fetches all products from the same seller via
 * moreFromSeller API and renders them in a collection-style grid.
 * Reads the `id` (signInInfoKey) or `sku` query parameter to identify the seller.
 */
(function () {
  'use strict';

  var SECTION_NAME = 'product-card';
  var LIMIT = 100;

  function getLocalePrefix(container) {
    var root = (container && container.dataset.localeRoot) || '';
    return root === '/' ? '' : root;
  }

  function fetchAvailability(handle, localePrefix) {
    var prefix = localePrefix || '';
    var url = prefix + '/products/' + encodeURIComponent(handle) + '.js';
    return fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) { return data && data.available === true; })
      .catch(function () { return false; });
  }

  function renderCardHtml(handle, localePrefix) {
    var prefix = localePrefix || '';
    var url = prefix + '/products/' + encodeURIComponent(handle) + '?sections=' + SECTION_NAME;
    return fetch(url)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) { return data && data[SECTION_NAME] ? data[SECTION_NAME] : null; })
      .catch(function () { return null; });
  }

  function getHandlesFromProducts(products) {
    if (!Array.isArray(products)) return [];
    return products
      .map(function (p) {
        if (p && typeof p.handle === 'string' && p.handle) return p.handle;
        if (p && p.url) {
          var path = typeof p.url === 'string' ? p.url : '';
          var match = path.replace(/^https?:\/\/[^/]+/, '').match(/\/products\/([^/?]+)/);
          return match ? match[1] : null;
        }
        return null;
      })
      .filter(Boolean);
  }

  function init() {
    var container = document.querySelector('[data-section-id][id^="seller-section-"]');
    if (!container) return;

    var sectionId = container.dataset.sectionId;
    var localePrefix = getLocalePrefix(container);
    var loadingEl = document.getElementById('seller-loading-' + sectionId);
    var contentEl = document.getElementById('seller-content-' + sectionId);
    var gridEl = document.getElementById('seller-grid-' + sectionId);
    var gridWrapper = document.getElementById('seller-grid-wrapper-' + sectionId);
    var emptyEl = document.getElementById('seller-empty-' + sectionId);

    var params = new URLSearchParams(window.location.search);
    var sellerId = params.get('id');
    var sku = params.get('sku');
    var baseUrl = window.API_BASE_URL.replace(/\/$/, '');

    if ((!sellerId && !sku) || !window.API_BASE_URL) {
      showEmpty();
      return;
    }

    var apiUrl;
    if (sellerId) {
      apiUrl = baseUrl + '/moreFromSeller/seller/' + encodeURIComponent(sellerId) + '?limit=' + LIMIT;
    } else {
      apiUrl = baseUrl + '/moreFromSeller/' + encodeURIComponent(sku) + '?limit=' + LIMIT;
    }

    fetch(apiUrl)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) {
        var products = json && json.products ? json.products : [];
        var handles = getHandlesFromProducts(products);

        if (handles.length === 0) {
          showEmpty();
          return;
        }

        var rendered = 0;
        var total = handles.length;

        handles.forEach(function (handle) {
          Promise.all([fetchAvailability(handle, localePrefix), renderCardHtml(handle, localePrefix)]).then(function (results) {
            total--;
            if (results[0] && results[1]) {
              var li = document.createElement('li');
              li.className = 'grid__item';
              li.innerHTML = results[1];
              gridEl.appendChild(li);
              rendered++;
            }
            if (total === 0) {
              if (rendered === 0) {
                showEmpty();
              } else {
                showContent();
              }
            }
          });
        });
      })
      .catch(function () {
        showEmpty();
      });

    function showContent() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (contentEl) {
        contentEl.classList.remove('hidden');
        contentEl.setAttribute('aria-hidden', 'false');
      }
      if (gridWrapper) gridWrapper.classList.remove('hidden');
    }

    function showEmpty() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (contentEl) {
        contentEl.classList.remove('hidden');
        contentEl.setAttribute('aria-hidden', 'false');
      }
      if (emptyEl) emptyEl.classList.remove('hidden');
      if (gridWrapper) gridWrapper.style.display = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
